import { findTracking } from 'ts-tracking-number'

export default findTracking
